@if (hasFieldNotes('apiNumber')) {
  <div>
    <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
  </div>
}
<well-selector [organization]="organization" [enableSelections]="enableWellSelection" [reportType]="reportType" (throw)="handleError($event)" (selectedWells)="onWellsSelected($event)"></well-selector>
@if (showLaterSteps) {
  <div class="margin-top">
    <unitization [activeStep]="step" [application]="application" [form]="form?.get('unitization')" (openChanged)="setStep($event)" (notesRequested)="handleNotesRequested($event)"></unitization>
    <plat-documentation [activeStep]="step" [application]="application" [form]="form?.get('documentation')" [onBaseDocumentTypes]="onBaseDocumentTypes" (openChanged)="setStep($event)" (notesRequested)="handleNotesRequested($event)"></plat-documentation>
    <plat-location [activeStep]="step" [application]="application" [form]="form?.get('wellInformation')" (openChanged)="setStep($event)" (notesRequested)="handleNotesRequested($event)"></plat-location>
    <plat-fees [activeStep]="step" [application]="application" [form]="form?.get('payments')" [config]="config" [organization]="organization" (openChanged)="setStep($event)" (feesGenerated)="onFeesGenerated($event)" (authorizationRequested)="onAuthorizationRequested($event)" (receiptIssued)="onReceiptIssued($event)" (authorizationResponseReceived)="updateResponse($event)" (notesRequested)="handleNotesRequested($event)"></plat-fees>
    @if (onBehalf) {
      <div>
        <plat-reviewer [activeStep]="step" [application]="application" [form]="form?.get('review')" (openChanged)="setStep($event)" (notesRequested)="handleNotesRequested($event)"></plat-reviewer>
      </div>
    }
    <div class="grid-x margin-top">
      @switch (true) {
        @case (!onBehalf) {
          <div class="cell small-12 medium-12 large-12 bold text-align-center">
            I certify that the information provided is true and accurate, to the best of my knowledge.
          </div>
          <div class="large-12 medium-12 small-12 text-align-center">
            <span class="padding-right-small">
              <button (click)="save()" class="button">Save for Later</button>
            </span>
            <span class="padding-right-small">
              <button (click)="submit()" class="button" [disabled]="disableSubmit">Submit</button>
            </span>
            <span class="padding-right-small">
              <button class="button" (click)="cancel()">Cancel</button>
            </span>
          </div>
        }
        @case (onBehalf) {
          <div class="cell small-12 medium-12 large-12 bold text-align-center">
            I certify that the information provided is true and accurate, to the best of my knowledge.
          </div>
          <div class="large-12 medium-12 small-12 text-align-center">
            <span class="padding-right-small">
              <button (click)="save()" class="button">Save for Later</button>
            </span>
            <span class="padding-right-small">
              <button (click)="onAccept()" class="button" [disabled]="disableSubmit">Accept</button>
            </span>
            <span class="padding-right-small">
              <button class="button" (click)="cancel()">Cancel</button>
            </span>
          </div>
        }
      }
    </div>
  </div>
}
